import axios from 'axios'

import { API_URL } from '../../api/api'
import api from '../../api/apiLogin'
import actions from './loginActions'

// Авторизация оператора
export const auth = (login: string, password: string) => async (dispatch: any) => {
    dispatch(actions.setIsInputClick(true))
    const responce = await api.login(login, password)
    dispatch(actions.setIsInputClick(false))

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                localStorage.setItem('token', responce.data.apiToken)
                dispatch(actions.setIsAuthorized(true))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Проверка авторизации оператора
export const checkAuth = () => async (dispatch: any) => {
    const responce = await axios.get<any>(`${API_URL}/auth/checkAuth`, { headers: { "API_KEY": localStorage['token'] }, withCredentials: true })

    switch (responce.data.statusCode) {
        case 'OK': // Все ОК
            dispatch(actions.setIsAuthorized(true))
            return { code: 'OK' }

        default: return { code: responce.data.statusCode }
    }
}

// Выход оператора из приложения
export const logout = () => async (dispatch: any) => {
    const responce = await api.logout()
    
    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                localStorage.removeItem('token')
                dispatch(actions.setLogout())
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Авторизация оператора
export const getMyProfile = () => async (dispatch: any) => {
    const responce = await api.getMyProfile()

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(actions.setIsAuthorized(true))
                dispatch(actions.setLoginProfile(
                    responce.data.login, responce.data.lastName, responce.data.firstName, responce.data.secondName,
                    responce.data.accountCreateDate, responce.data.loginPosition, responce.data.loginAvatar,
                    responce.data.loginPhoneNumber, responce.data.accessLevelList
                ))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Загрузка аватарки пользователя
export const uploadAvatar = (file: any) => async (dispatch: any) => {
    const responce = await api.uploadAvatar(file)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(getMyProfile())
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Изменение профиля оператора
export const editMyProfile = (lastName: string, firstName: string, secondName: string, position: string, phoneNumber: string) => async (dispatch: any) => {
    const responce = await api.editMyProfile(lastName, firstName, secondName, position, phoneNumber)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(getMyProfile())
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}
